import React, { useState } from 'react';
import { Modal, Form, Input, Select, message } from 'antd';

const { TextArea } = Input;
const { Option } = Select;

const UpdateTicketModal = ({
  visible,
  onCancel,
  onUpdate,
  ticket
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleUpdate = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      await onUpdate(ticket.id, values);

      form.resetFields();
      setLoading(false);
      message.success('Ticket updated successfully');
    } catch (error) {
      setLoading(false);
      if (error.errorFields) {
        // Validation error
        return;
      }
      console.error('Error updating ticket:', error);
      message.error('Failed to update ticket');
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title={`Update Ticket: ${ticket?.ticket_number || ''}`}
      open={visible}
      onOk={handleUpdate}
      onCancel={handleCancel}
      okText="Update Ticket"
      confirmLoading={loading}
      width={600}
    >
      <Form
        form={form}
        layout="vertical"
        name="update_ticket_form"
      >
        <Form.Item
          name="update_text"
          label="Comment / Update"
          rules={[
            {
              required: true,
              message: 'Please enter an update or comment'
            }
          ]}
        >
          <TextArea
            rows={4}
            placeholder="Add a comment or describe what you've done..."
          />
        </Form.Item>

        <Form.Item
          name="status"
          label="Change Status (Optional)"
          initialValue={ticket?.status}
        >
          <Select placeholder="Select new status">
            <Option value="open">Open</Option>
            <Option value="in_progress">In Progress</Option>
            <Option value="resolved">Resolved</Option>
            <Option value="closed">Closed</Option>
          </Select>
        </Form.Item>

        <Form.Item
          name="assigned_to"
          label="Reassign To (Optional)"
          initialValue={ticket?.assigned_to}
        >
          <Input placeholder="Enter name to reassign ticket" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UpdateTicketModal;
